var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ix-section',{attrs:{"loading":_vm.loading}},[(_vm.latestQuestionnaireId)?_c('esg-company-section',{attrs:{"venture-id":_vm.ventureId,"all-esg-questionnaires":_vm.allEsgQuestionnaires,"initial-questionnaire-id":_vm.initialQuestionnaireId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }